<template>
    <div>
      <ResetPassword/>
    </div>
</template>
  
<script>
  import ResetPassword from "../components/ResetPassword.vue";
  export default {
    name: 'ResetView',
    components: {
      ResetPassword
    }
  }
</script>